import { TypekitFont } from "types";
import {
  BeeFontData,
  APIFormatBorderStyleOptions,
  ColorsFormData,
  APIFormatThemeLayoutData,
} from "containers/admin/clients/client/theme-page/preview/preview.types";
import {
  BlockType,
  DeviceType,
  PaddingPropertyType,
} from "containers/admin/clients/client/theme-page/preview/sub-tabs/layout/layout.types";

export const createAdobeFontSlugToCssNameMap = (
  adobeFontsList: TypekitFont[],
): Map<string, string> => {
  const fontMap = new Map<string, string>();

  adobeFontsList.forEach((font) => {
    if (font.slug && font.css_names && font.css_names.length > 0) {
      fontMap.set(font.slug, font.css_names[0]);
    }
  });

  return fontMap;
};

export const getColor = (color: string, colors: ColorsFormData): string => {
  if (color === "none") return "transparent";

  return color.startsWith("#") ? color : colors[color as keyof ColorsFormData] || "transparent";
};

export const getFontFamily = (
  fontValue: string,
  beeFonts: BeeFontData[] = [],
  fallbackFontFamily?: string,
): string => {
  const currentFont = beeFonts.find((font: BeeFontData) => {
    return font.value === fontValue;
  });

  if (!currentFont?.fontFamily) return "";

  // Extract the primary font name - handle both Adobe and Google font formats
  const primaryFont = currentFont.fontFamily.split(",")[0];

  if (!primaryFont) return currentFont.fontFamily;

  if (fallbackFontFamily) {
    // create custom fallback font stack
    return `${primaryFont}, ${fallbackFontFamily.replace(/^'([^']+)'/, "$1")}`;
  }

  return currentFont.fontFamily;
};

export const getBorder = (border: APIFormatBorderStyleOptions, colors: ColorsFormData): string => {
  const borderColor = border.color.startsWith("#")
    ? border.color
    : colors[border.color as keyof ColorsFormData];

  return border.style === "none" ? "none" : `${border.width}px ${border.style} ${borderColor}`;
};

export const getBrandStyleBorder = (
  border: APIFormatBorderStyleOptions,
  colors: ColorsFormData,
): string => {
  const borderColor = border.color.startsWith("#")
    ? border.color
    : colors[border.color as keyof ColorsFormData];

  return border.style === "none" ? "0px" : `${border.width}px ${border.style} ${borderColor}`;
};

export const getContentBlockPadding = (
  layout: APIFormatThemeLayoutData,
  blockType: BlockType,
  device: DeviceType,
  paddingProperty: PaddingPropertyType,
): string => {
  if (layout.contentBlock.group === "all-blocks") {
    return `${layout.contentBlock.allBlocks[device][paddingProperty]}px`;
  }
  return `${layout.contentBlock[blockType][device][paddingProperty]}px`;
};

export const getButtonWidth = (width: string): string => {
  switch (width) {
    case "auto":
      return "auto";
    default:
      return `${width}%`;
  }
};

export const getLineHeight = (lineHeight: number | string): string => {
  const numValue = Number.parseFloat(String(lineHeight));

  if (Number.isNaN(numValue) || numValue < 1.4) {
    return "120%";
  }
  if (numValue < 1.7) return "150%";
  if (numValue < 1.9) return "180%";

  return "200%";
};
